import React, { useEffect, useState,useRef } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Drawer,
  Descriptions,
  Anchor,
  Tag,
  notification,
  Modal,
  Input
} from "antd";
import { ExclamationCircleOutlined,SearchOutlined } from "@ant-design/icons";
import Highlighter from 'react-highlight-words';
import { Table } from "ant-table-extensions";
import http from "../../../../helpers/http";
import helper from "../../../../helpers/helper";
import config from "../../../../config/config";
import _ from "lodash";
import "./style.css";
function DiwaliBonanza() {
  const { confirm } = Modal;
  const [loading, setloading] = useState(false);
  const [drawerOpen, setdraweropen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});


  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);



  const moduleNamePural = "Diwali Bonanza";
  const base_url = config.api_url + "admin/leads/diwali-bonanza"; //without trailing slash
  const image_url = config.api_url + "public/uploads/landing-page/"; //with trailing slash

  const { Link } = Anchor;

  const handleView = async (id) => {
    const { data } = await http.get(`${base_url}/${id}`);

    if (data) {
      setData(data);
      setdraweropen(true);
    }
  };

  const handleDrawerClose = () => {
    setData({});
    setdraweropen(false);
  };

  const fetchDatas = async () => {
    setloading(true);
    const data = await http.get(base_url);

    if (data) {
      setDatas(data.data);
    }
    setloading(false);
  };


  const handleDelete = async (id) => {
    const result = await http.delete(`${base_url}/${id}`);
    if (result) {
      notification["success"]({
        message: `Lead Deleted Successfully`,
      });
    }

    fetchDatas();
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: `Are you sure delete this Lead?`,
      icon: <ExclamationCircleOutlined />,
      content: "",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",

      onOk() {
        return handleDelete(id);
      },
      onCancel() {},
    });
  };


  useEffect(() => {
    fetchDatas();
  }, []);




  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };


  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      return (
        <div
        style={{
          padding: 8,
        }}
      >
          <Input
            autoFocus
            placeholder="Type text here"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => {
              confirm();
            }}
            onBlur={() => {
              confirm();
            }}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          ></Input>
          <Space>
          {/* <Button
           onClick={() => {
            clearFilters();
            setSelectedKeys(selectedKeys[0]);
            confirm();
           

          }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button> */}
          </Space>
        </div>
      );
    },
    filterIcon: () => {
      return <SearchOutlined />;
    },
    onFilter: (value, record) => {
      return record[dataIndex].toLowerCase().includes(value.toLowerCase());
    },
  });








  const columns = [
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
    
      ellipsis: true,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      ellipsis: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Contact No",
      dataIndex: "phone",
      key: "phone",
      
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },

    {
      title: "Created At",
      render: (text, record) => {
        return helper.UTCDate(record.createdAt);
      },
      key: "createdAt",
      dataIndex:"createdAt"
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              handleView(record._id);
            }}
          >
            View Detail
          </Button>
          {/* <Button
            type="danger"
            onClick={() => {
              showDeleteConfirm(record._id);
            }}
          >
            Delete
          </Button> */}
        </Space>
      ),
    },
  ];

  const fields: ITableExportFields = {
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    phone: "Phone",
    gender: "Gender",
    age: "Age",
    coupon_product: "In which Laxmi Product have you received this coupon?",
    is_samosa_seen: "Have you seen Laxmi Samosa in the stores near you?",
    is_veg_seen: "Have you seen the Laxmi Frozen Vegetable range in the stores near you?",
    code: "Coupon Code",
    state: "State",
    city: "City",
    zip: "Zip Code",
    
    city: {
      header: "city",
      formatter: (_fieldValue, record) => {
        return _.replace(_.deburr(record.city),/‘/g,'');
      },
    },
    
    createdAt: {
      header: "Created At",
      formatter: (_fieldValue, record) => {
        return helper.UTCDate(record.createdAt);
      },
    },
  };




  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={datas}
                loading={loading}
                exportableProps={{
                  // showColumnPicker: true,
                  fields,
                  fileName: moduleNamePural,
                }}
                searchableProps={{
                  fuzzySearch: true,
                  // searchFunction:(dataSource,searchTerm)=>{
                  //   return dataSource;
                  // }
                  fuseProps:{
                    // distance:1000,
                    useExtendedSearch:true
                  }
                }}
               
              />
            </Card>

            <Drawer
              title="Lead Details"
              placement="right"
              onClose={handleDrawerClose}
              visible={drawerOpen}
              size="large"
            >
              {data && (
                <Descriptions
                  bordered
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                >
                  <Descriptions.Item label="First Name">
                    {data.first_name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Last Name">
                    {data.last_name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Email">
                    {data.email}
                  </Descriptions.Item>
                  <Descriptions.Item label="Contact No">
                    {data.phone}
                  </Descriptions.Item>
                  <Descriptions.Item label="Gender">
                    {data.gender}
                  </Descriptions.Item>
                  <Descriptions.Item label="Age">{data.age}</Descriptions.Item>
                  <Descriptions.Item label="In which Laxmi Product have you received this coupon?">{data.coupon_product}</Descriptions.Item>
                  <Descriptions.Item label="Have you seen Laxmi Samosa in the stores near you?">{data.is_samosa_seen}</Descriptions.Item>
                  <Descriptions.Item label="Have you seen the Laxmi Frozen Vegetable range in the stores near you?">{data.is_veg_seen}</Descriptions.Item>
                  <Descriptions.Item label="Coupon Code">{data.code}</Descriptions.Item>

                  <Descriptions.Item label="State">{data.state || "-"}</Descriptions.Item>
                  <Descriptions.Item label="City">{_.replace(_.deburr(data.city),/‘/g,'')|| "-"}</Descriptions.Item>
                  <Descriptions.Item label="Zip Code">{data.zip || "-"}</Descriptions.Item>
                  
                  {/* <Descriptions.Item label="Consent">
                    <Tag color={data.consent ? "green" : "red"}>
                      {data.consent ? "Yes" : "No"}
                    </Tag>
                  </Descriptions.Item> */}
                  <Descriptions.Item label="Created At">
                    {helper.UTCDate(data.createdAt)}
                  </Descriptions.Item>
                </Descriptions>
              )}
            </Drawer>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default DiwaliBonanza;
